
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tech-due-diligence",
      function () {
        return require("private-next-pages/tech-due-diligence/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tech-due-diligence"])
      });
    }
  